var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 44,
    fill: "#D8D8E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 24.3086C23.6625 24.3086 24.9374 24.4736 26.325 24.8036C27.9 25.1886 29.1749 25.7019 30.15 26.3436C31.3125 27.0953 31.8937 27.9386 31.8937 28.8736V31.1836H13.1062V28.8736C13.1062 27.9386 13.6874 27.0953 14.85 26.3436C15.825 25.7019 17.0999 25.1886 18.675 24.8036C20.0625 24.4736 21.3374 24.3086 22.5 24.3086Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4999 21.9995C21.6562 21.9995 20.8781 21.7932 20.1656 21.3807C19.453 20.9682 18.8859 20.4136 18.464 19.717C18.0421 19.0203 17.8312 18.2595 17.8312 17.4345C17.8312 16.6094 18.0421 15.8395 18.464 15.1245C18.8859 14.4094 19.453 13.8457 20.1656 13.4332C20.8781 13.0207 21.6562 12.8145 22.4999 12.8145C23.3437 12.8145 24.1218 13.0207 24.8343 13.4332C25.5468 13.8457 26.114 14.4094 26.5359 15.1245C26.9577 15.8395 27.1687 16.6094 27.1687 17.4345C27.1687 18.2595 26.9577 19.0203 26.5359 19.717C26.114 20.4136 25.5468 20.9682 24.8343 21.3807C24.1218 21.7932 23.3437 21.9995 22.4999 21.9995Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f17fe334fa54632c5dd42a33c917be17.svg";
export { ForwardRef as ReactComponent };